/* eslint-disable guard-for-in, no-restricted-syntax */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-await-in-loop */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RandExp from 'randexp';
import { FormattedMessage, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';
import moment from 'utils/moment';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack';
import Button from '../../../components/button';
import Loading from '../../../components/loading';
import CustomFields from '../../../components/customFields/CustomFields';
import Modal from '../../../components/modal';
import Tags from '../../../components/tags';
import { DATE_SUBMIT_FIELD_TYPES, importAllImages, validateMinMax } from '../../../utils/helpers';
import { fetchFormAnswerDetails, actionClearForm, createFormAnswer, getPortalFormSchema, actionSaveTabView } from '../redux/actions';
import closeIcon from '../../../icons/closeIcon.svg';
import styles from './form_complete.module.scss';
import FormSubmitted from '../components/FormSubmitted';
import { FORM_PUBLIC_STATUS } from '../../../constants/ModelStatus';
import { MYFORMS } from '../../../constants/RouterConstants';
import { S3Uploads, GetFileName } from '../../services';
import Clickable from '../../../components/clickable/Clickable';
import { getFieldError, getPhoneConvert, handleMultiFieldErrorList } from '../utils/helpers';
import CollapsibleSections from '../../../components/customFields/CollapsibleSections';

const handleMultiGridSpecificFieldError = (field, formValues, handleSectionErrorMultiLevelField, handleMultiColumnGLS, form_data) => {
  let errorData = [];
  let isConditionallyVisible = true;
  if (field.conditional_field) {
    const conditionValues = field?.conditional_values;
    let fieldValue = form_data[field.conditional_field?.key];
    if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
    if (typeof fieldValue === 'object' && fieldValue?.level_0) {
      isConditionallyVisible = Object.values(fieldValue)?.filter(value => value !== '')?.join()
        === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
    } else {
      isConditionallyVisible = conditionValues.some(value => fieldValue?.includes(value?.value));
    }
  }
  Object.entries(field.multiple_fields).forEach(([key, config]) => {
    if (isConditionallyVisible) {
      const isMandatory = config.mandatory_multi_field;
      const fieldType = config?.type?.key;
      const value = formValues[key];
      const isMultiLevel = fieldType === 'multi_level';

      const isEmpty = value === null
        || value === undefined
        || value === ''
        || (Array.isArray(value) && value.length === 0);
      const field_type = fieldType === 'string' ? config?.validator : config?.inputType;
      const max_min = field_type || {};
      let errorMinMax = false;
      if (max_min?.type === 'min_max') {
        const length = value?.length ?? 0;
        const min = max_min?.minValue && +max_min?.minValue;
        const max = max_min?.maxValue && +max_min?.maxValue;

        if (min && length < min) {
          errorMinMax = true;
        } else if (max && length > max) {
          errorMinMax = true;
        }
      }
      if (isMultiLevel) {
        if ((isEmpty || handleSectionErrorMultiLevelField(config, value)) && isMandatory) {
          errorData.push(config.title);
        }
      } else if (fieldType === 'string' && config?.text_aera) {
        const showValidationLimit = value?.length > config.validation_limit;

        if (isMandatory) {
          if (isEmpty || showValidationLimit) {
            errorData.push(config.title);
          }
        } else if (!isEmpty && showValidationLimit) {
          errorData.push(config.title);
        }
      } else if (isMandatory && isEmpty) {
        errorData.push(config.title);
      } else if (isMandatory && config?.type?.key === 'dataSource-ds8') {
        const showError = handleMultiColumnGLS(key, config, value);
        if (showError) {
          errorData.push(config.title);
        }
      } else if (['string', 'number'].includes(fieldType) && !isEmpty && errorMinMax) {
        errorData.push(config.title);
      }
    }
  });
  return errorData;
};

class DuplicateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFormErrors: false,
      answers: {},
      apiStatus: undefined,
      apiStatusError: undefined,
      loadingStatus: false,
      errorsList: {},
      formActiveIndex: 0,
      groupedSections: [],
      formTabFeilds: [],
      opsLogTags: [],
      isDraft: false,
      errorListMCG: {},
      errorModal: false,
      fieldErrorsList: [],
      warningModal: false,
      alert: false
    };
    this.images = importAllImages(
      require.context(
        '../../../icons/inspection-icons',
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    this.URL = MYFORMS;
    if (props?.match?.url?.includes('arff')) {
      this.URL = '/arff/forms';
    }
  }

  componentDidMount() {
    const {
      actionFetch,
      match,
      flowAnswer
    } = this.props;
    const id = match?.params?.id || flowAnswer;
    actionFetch(id);
  }

  static getDerivedStateFromProps(props, state) {
    if (
      !state.requiredMap
      && props.form
      && Object.keys(props.form).length > 0 && typeof props.form?.form_version === 'object'
    ) {
      const {
        form_version: { schema = {} }
      } = props.form;
      let requiredMap = {};
      let fieldErrors = {};
      const conditionalFields = {};
      const attachmentFields = [];
      const signatureFields = [];
      let placeHolders = {};
      const sections = [];
      let currentSection = null;
      const firstGroup = [];
      (schema?.fields || []).forEach((detailField) => {
        if (detailField.type === 'header' && detailField?.settings?.showTab) {
          currentSection = {
            header: detailField.title,
            items: []
          };
          sections.push(currentSection);
        } else if (currentSection) {
          currentSection.items.push(detailField);
        } else {
          firstGroup.push(detailField);
        }
        if (detailField.type !== 'header') {
          requiredMap = {
            ...requiredMap,
            [detailField.id]: detailField.required
          };
          if (!detailField.conditional) {
            fieldErrors = {
              ...fieldErrors,
              [detailField.id]: props.form.data?.[detailField.id]
                ? false
                : detailField.required
            };
          } else {
            conditionalFields[
              detailField?.conditional_field?.key
            ] = detailField;
          }
        }
        if (detailField.type === 'attachments') attachmentFields.push(detailField.id);
        if (detailField.type === 'signature') signatureFields.push(detailField.id);

        if (detailField?.validators?.length > 0 && detailField.validators[0]?.type === 'Regex' && detailField.validators[0]?.value) {
          let randexp = new RandExp(detailField.validators[0]?.value).gen();
          if (detailField.validators[0]?.label === 'Email') {
            randexp = 'name@email.com';
          }
          placeHolders = {
            ...placeHolders,
            [detailField.id]: randexp
          };
        }
      });
      if (firstGroup?.length > 0 && sections?.length > 0) {
        const firstIndexItems = sections?.map(e => e.items)[0];
        firstIndexItems.unshift(...firstGroup);
        sections[0].items = firstIndexItems;
      }
      const firstGroupedItems = sections?.map(e => e.items)[0] || [];

      return {
        ...state,
        requiredMap,
        fieldErrors,
        attachmentFields,
        answers: {
          created_by: {
            id: props.form.created_by && props.form.created_by.id,
            fullname: props.form.created_by && props.form.created_by.fullname
          },
          ...props.form.data,
          source: props.form.source,
          approvals: props.form.settings?.approvals,
          name: props.form.public_user_info && props.form.public_user_info.name,
          email:
            props.form.public_user_info && props.form.public_user_info.email,
          phone:
            props.form.public_user_info && props.form.public_user_info.phone
        },
        conditionalFields,
        signatureFields,
        placeHolders,
        groupedSections: sections,
        formTabFeilds: firstGroupedItems?.length > 0 ? firstGroupedItems : schema.fields
      };
    }

    return state;
  }

  componentDidUpdate(prevProps) {
    const { dataSourceAction, dataSourceValues, createAction, createdFormAnswer, opslog_tags, history, form, fetchAnswerAction,
      actionFetchFormSchema, getFormsSchemaAction, isDraft } = this.props;
    const { groupedSections, loadingStatus, opsLogTags, answers } = this.state;
    if (
      prevProps?.fetchAnswerAction?.loading === true
      && fetchAnswerAction?.loading === false
    ) {
      if (form?.parent_key) {
        actionFetchFormSchema(form?.parent_key);
      }
    }
    if (prevProps?.createAction?.success === false && createAction?.success === true && loadingStatus) {
      if (answers?.approvals && !isDraft) {
        history.push(`${this.URL}/${createdFormAnswer?.key}/detail`);
      }
      this.setState({
        loadingStatus: false,
        apiStatus: createAction?.success
      });
      this.handleTabClick(0);
    }
    if (createAction?.error === true && loadingStatus) {
      this.setState({
        apiStatusError: createAction.error,
        loadingStatus: false
      });
    }
    if (opslog_tags && opsLogTags?.length === 0 && answers?.tags
      && !(answers?.tags?.length === opslog_tags?.filter(e => !e?.status)?.length)) {
      this.updateTags(opslog_tags?.filter(e => !e?.status), answers?.tags || []);
    }
    if (prevProps?.getFormsSchemaAction?.loading === true
      && getFormsSchemaAction?.loading === false) {
      let tagData = this.checkValidTags(form.tags);
      tagData = tagData?.map(tag => ({ id: tag[0], name: tag[0] }));
      let newTags = [];
      let oldTags = [];
      if (opslog_tags && opslog_tags?.length > 0) {
        opslog_tags.forEach((e) => {
          tagData.forEach((t) => {
            if (e?.status === 0 && t?.name === e?.name) {
              newTags = [...newTags, e];
            } else if (e?.status === 1 && t?.name === e?.name) {
              oldTags = [...oldTags, e];
            }
          });
        });
      }
      this.setState({
        answers: {
          ...answers,
          tags: tagData,
          oldTags
        },
        loadingStatus: false
      });
    }
    if (dataSourceValues && typeof dataSourceValues === 'object'
     && Object.keys(dataSourceValues)?.length > 0 && groupedSections?.length>0
      && prevProps.dataSourceAction?.loading === true && dataSourceAction?.loading === false) {
      let values = '';
      groupedSections.forEach((val) => {
        val.items.some((item) => {
          if (dataSourceValues[item.id] && item.type === 'dataSourceMultiLevel') {
              values = dataSourceValues[item.id].find(v => v?.name === item?.global_location?.name)?.location_levels;
              return true;
          }
          return false;
        });
      });
      this.setState({ sourceValues: values });
    }
  }

  componentWillUnmount() {
    const { acitonGetTabView } = this.props;
    acitonGetTabView();
  }

  getFileNames = async (count) => {
    const response = await GetFileName.getPermitUploadFileName(count);
    return response;
  };

  getErrorAlert = (value) => {
    this.setState({ alert: value });
  }

  setAlert = (value) => {
    this.setState({ alert: value });
  }

  toastAlert = () => {
    toast.error('Attachment upload failed. Please try again.');
    this.setAlert(false);
  }

  uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await this.getFileNames(attachments.length);
    const list = [];
    if (fileIds) {
      await this.doS3Upload(attachments, fileIds, 'myForms', this.getErrorAlert)
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  checkValidTags = (data) => {
    if (data !== undefined && data?.length > 0) {
      const validatedTags = [];
      data.forEach((tag) => {
        const tagsArray = [];
        if (typeof tag === 'string') {
          tagsArray.push(tag);
        } else if (tag && tag?.length > 0) {
          tag.forEach((t) => {
            if (typeof t === 'string') {
              tagsArray.push(t);
            }
          });
        }
        if (tagsArray.length > 0) {
          validatedTags.push(tagsArray);
        }
      });
      return validatedTags;
    }
    return [];
  };

  goBackToForms = () => {
    const {
      history,
      flowFieldId,
      handleFlowField,
      flowAnswer
    } = this.props;
    if (flowFieldId) {
      handleFlowField(flowAnswer, flowFieldId);
    } else {
      history.push(`${this.URL}`);
    }
  };

  updateTags = (allTags, tags) => {
    let updatedData = [];
    if (allTags && tags?.length === 0) {
      updatedData = allTags?.map(e => ({ id: e?.name, name: e?.name }));
    } else {
      updatedData = allTags?.filter(value => tags?.find(i => i?.name === value?.name)?.name !== value?.name);
    }
    this.setState({ opsLogTags: updatedData });
  };

  handleRemoveTag = (tag, type = 'new') => {
    const { answers } = this.state;
    if (type === 'new') {
      const updatedOpsLogTags = answers?.tags?.filter(e => e.id !== tag.id);
      this.setState(prev => ({ opsLogTags: [...prev?.opsLogTags, tag], answers: { ...answers, tags: updatedOpsLogTags } }));
    } else {
      const updatedOpsLogTags = answers.oldTags.filter(e => e.id !== tag.id);
      this.setState({ answers: { ...answers, oldTags: updatedOpsLogTags } });
    }
  };

  checkAllChecklistsSelected =(fieldId, errorcheck) => {
    const { answers, formTabFeilds } = this.state;
    const isRequired = formTabFeilds?.filter(each => each.id===String(fieldId))?.[0]?.required || false;
    let flag = false;
    if (isRequired && answers?.[fieldId]) {
      const answered = Object.keys(answers[fieldId]).filter(field => field!=='version');
      let questions = formTabFeilds?.filter(each => each.id===fieldId)?.[0]?.schema?.fields || [];
      questions = questions?.filter(each => each.type==='inspection');
      if (answered.length === questions.length) {
        flag=answered.every((each) => {
          const qtnsChecklists = questions.filter(e => e.id=== each)?.[0]?.checklist?.length;
          if (Object.keys(answers[fieldId][each]).length === qtnsChecklists) {
            return true;
          }
          return false;
        });
      }
    }
    if (errorcheck && flag) {
      return flag;
    }
    if (flag || !isRequired) {
      this.handleFieldErrorChanged(fieldId, false);
      this.setState({ showFormErrors: false });
    }
    return flag;
  }

  handleCheckListAnswer = (fieldId, checkLisId, subCheckListKey, pass, remarks) => {
    const { answers, formTabFeilds } = this.state;
    const version= formTabFeilds?.length > 0 && formTabFeilds.find(field => field.id===fieldId)?.version;
    const useCheckObj = {
      [fieldId]: {
        ...answers?.[fieldId],
        version,
        [checkLisId]: {
          ...answers?.[fieldId]?.[checkLisId],
          [subCheckListKey]: {
            ...answers?.[fieldId]?.[checkLisId]?.[subCheckListKey],
            check_lilst_status: pass,
            checklist_remarks_list: remarks
          }
        }
      }
    };
    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        ...useCheckObj
      }
    }), () => this.checkAllChecklistsSelected(fieldId));
  }

  copyFieldData = (fields, fieldId, answer, answers, currentField) => {
    fields.forEach((field) => {
      const conditional = fieldId === field?.settings?.conditionalCopyField && currentField?.type === 'select'
      ? field?.settings?.conditionalCopyValues?.some(i => i?.value === answer) : answer === true;
      const withoutCondition = !field?.settings?.conditionalCopyField || field?.settings?.conditionalCopyField === '';
      if (conditional || withoutCondition) {
        const ans = (conditional && answers[field?.settings?.selectedCopyField]) || (withoutCondition && answer);
        this.handleFieldErrorChanged(field.id, !ans);
        this.setState(prevState => ({
            answers: {
              ...prevState.answers,
              [field.id]: ans || ''
            }
          }));
        }
      });
  };

  validateRegexValue = (answer, regexValue, isMultipleEmail) => {
  this.invalidEmailCount = 0;
  this.invalidEmails = [];
  if (!answer) return false;
  if (isMultipleEmail) {
    const invalidEmails = answer
      ?.split(',')
      ?.filter((e) => {
        if (typeof e !== 'string') return false;
        const trimmedEmail = e?.trim();
        return trimmedEmail && !regexValue?.test(trimmedEmail);
      });
    this.invalidEmails = invalidEmails;
    this.invalidEmailCount = invalidEmails?.length;
    return invalidEmails.length > 0;
  }
  return !regexValue?.test(answer);
};


  resolveConcatValue = (field, answers, orderedFields) => {
  if (
    !field?.settings?.concatFields
    || !Array.isArray(field?.settings?.selectedContextualField)
    || !Array.isArray(orderedFields)
  ) {
    return null;
  }

  const selectedMap = {};
  field.settings.selectedContextualField.forEach((sf) => {
    selectedMap[sf.value] = sf;
  });

  const result = [];

  orderedFields.forEach((stateField) => {
    const selected = selectedMap[stateField.id];
    if (!selected) return;

    const val = answers?.[stateField.id];
    let output = '';

    if (val !== undefined && val !== null) {
      switch (selected?.type) {
        case 'address':
          output = typeof val === 'object'
            ? Object.values(val).filter(Boolean).join(' ')
            : String(val)
              .replace(/[^a-zA-Z0-9\s]/g, '')
              .replace(/\s+/g, ' ')
              .trim();
          break;

        case 'date':
        case 'datetime':
          output = new Date(val).toLocaleDateString();
          break;

        default:
          output = String(val);
      }
    }
    result.push(output);
  });

  return result.join(' ').replace(/\s+/g, ' ').trim();
};

  applyConcatFields = (fields, answers, orderedFields) => {
  const updatedAnswers = { ...answers };

  fields.forEach((field) => {
    if (!field?.settings?.concatFields) return;

    const value = this.resolveConcatValue(field, updatedAnswers, orderedFields);
    if (value !== null) {
      updatedAnswers[field.id] = value;
    }
  });

  return updatedAnswers;
};


  handleAnswerChanged = (answer, fieldId, section) => {
    const { conditionalFields, placeHolders, opsLogTags, groupedSections, requiredMap,
      formTabFeilds, errorsList, answers } = this.state;
    const { form: { form_version: { schema: { fields } } }, form, intl } = this.props;
    const copyField = formTabFeilds.filter(i => i?.settings?.copyField
      && (i?.settings?.selectedCopyField === fieldId || i?.settings?.conditionalCopyField === fieldId));
      if (copyField?.length > 0) {
        this.copyFieldData(copyField, fieldId, answer, answers, formTabFeilds?.find(i => i.id === fieldId));
      }
    if (conditionalFields?.[fieldId] && conditionalFields?.[fieldId].required) {
      const conditionValues = conditionalFields[fieldId]?.conditional_values;
      let fieldValue = answer;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      let enabelCondition = false;
      if (typeof fieldValue === 'object' && fieldValue?.level_0) {
        enabelCondition = Object.values(fieldValue)?.filter(value => value !== '')?.join()
        === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
      } else {
        enabelCondition = conditionValues.some(value => fieldValue?.includes(value?.value));
      }
      this.handleFieldErrorChanged(
        conditionalFields[fieldId].id,
        enabelCondition
      );
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          [fieldId]: answer,
          [conditionalFields[fieldId].id]: ''
        }
      }));
    } else if (fieldId === 'tags') {
      const updatedOpsLogTags = opsLogTags?.filter(e => e?.id !== answer?.id);
      this.setState(prev => ({
        opsLogTags: updatedOpsLogTags,
        answers: {
          ...prev?.answers,
          [fieldId]: [...prev?.answers?.tags, answer]
        }
      }));
    } else if (fieldId==='global_location') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], ...answer }
        }
      }));
    } else if (fieldId ==='location_attachment'|| fieldId ==='location_marked' || fieldId === 'selected_map') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], [fieldId]: answer }
        }
      }));
    } else if (fieldId ==='location') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], map_location: answer }
        }
      }));
    } else {
      let headerValidate = true;
      const fieldType = fields?.find(obj => obj.id === fieldId);
      if ((fieldType?.type === 'string' || fieldType?.type === 'number') && fieldType.validators?.length > 0
        && (fieldType.validators[0]?.value || fieldType.validators[0]?.type === 'min_max')) {
        if (fieldType.validators[0]?.type === 'Regex') {
          let convertValidtorValueToRegex = fieldType.validators[0].value;
          if (fieldType.validators[0]?.label === 'Custom Validation') {
            if (convertValidtorValueToRegex.endsWith('-')) {
              convertValidtorValueToRegex = fieldType.validators[0].value.slice(0, -1);
            }
            convertValidtorValueToRegex = `^${convertValidtorValueToRegex}$`;
          }
          let phoneValConvert = '';
          if (fieldType.validators[0]?.label === 'Phone Number') {
            ({ phoneValConvert, convertValidtorValueToRegex } = getPhoneConvert(answer));
          }
          const regexValue = new RegExp(convertValidtorValueToRegex);
          const isMultipleEmail = fieldType.validators[0]?.multiple_email;
          const hasRegexError = this.validateRegexValue(
            phoneValConvert || answer,
            regexValue,
            isMultipleEmail
          );
          if (answer && hasRegexError) {
            if (groupedSections?.length > 0) {
              const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
              groupedSections[findIndex].fieldErrors = true;
              headerValidate = false;
            }
            this.setState((prevState) => {
              const fieldError = getFieldError(fieldType.validators[0]?.label, fieldId, placeHolders, this.invalidEmailCount,
              fieldType.validators[0]?.multiple_email);
              return {
                errorsList: {
                  ...prevState.errorsList,
                  [fieldId]: fieldError
                },
                groupedSections
              };
            });
          } else {
            if (groupedSections?.length > 0) {
              const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
              groupedSections[findIndex].fieldErrors = false;
              headerValidate = true;
            }
            this.setState(prevState => ({
              errorsList: {
                ...prevState.errorsList,
                [fieldId]: ''
              },
              groupedSections
            }));
          }
        } else if (fieldType.validators[0]?.type === 'maxLength') {
          if (fieldType.validators[0]?.value < answer.length) {
            if (groupedSections?.length > 0) {
              const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
              groupedSections[findIndex].fieldErrors = true;
              headerValidate = false;
            }
            const fieldError = `Character limit exceeded. Max ${fieldType.validators[0]?.value} characters.`;
            this.setState(prevState => ({
              errorsList: {
                ...prevState.errorsList,
                [fieldId]: fieldError
              },
              groupedSections
            }));
          } else {
            if (groupedSections?.length > 0) {
              const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
              groupedSections[findIndex].fieldErrors = false;
              headerValidate = true;
            }
            this.setState(prevState => ({
              errorsList: {
                ...prevState.errorsList,
                [fieldId]: ''
              },
              groupedSections
            }));
          }
        } else if (fieldType.validators?.length > 0 && fieldType.validators[0]?.type === 'min_max') {
            const isRequired = requiredMap?.[fieldType.id] ?? fieldType.required;
            const { fieldError } = validateMinMax(answer, fieldType.validators, isRequired, intl);
            this.setState(prevState => ({
              errorsList: {
                ...prevState.errorsList,
                [fieldType.id]: fieldError
              },
              [fieldId]: answer
            }));
          }
      } if (groupedSections.length > 0 && headerValidate) {
        const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
        const sectionErrors = this.handleSectionErrorChanged(fieldId, answer, requiredMap, errorsList, formTabFeilds);
        if (groupedSections?.[findIndex]?.fieldErrors) {
          groupedSections[findIndex].fieldErrors = sectionErrors;
        }
      }
      if (fieldType?.type === 'multi_field' && answer?.length > 0) {
        this.setState((prevState) => {
          const updatedErrorListMCG=handleMultiFieldErrorList(fieldType, answer, fieldId, prevState);
          return { errorListMCG: updatedErrorListMCG };
        });
      }
      this.setState(
        (prevState) => {
          const updatedAnswers = {
            ...prevState.answers,
            [fieldId]: answer
          };
          const concatFields = fields.filter(f => f?.settings?.concatFields);
         concatFields.forEach((concatField) => {
           const concatValue = this.resolveConcatValue(concatField, updatedAnswers,
            formTabFeilds);
           if (concatValue !== null) {
             updatedAnswers[concatField.id] = concatValue;
             this.handleFieldErrorChanged(concatField.id, false);
           } else {
              this.handleFieldErrorChanged(concatField.id, true);
           }
         });
          return {
            answers: updatedAnswers,
            groupedSections
          };
        }
      );
    }

    // USED TO PERFORM CUSTOM JS LOGIC WHILE USER INPUTS SOMETHING INTO FIELD
    const beforeSubmitProcess = form?.latest_version?.trigger_config?.pre_custom_process;
    const checkInvolvedIds = form?.latest_version?.trigger_config?.involvedIds;
    if (beforeSubmitProcess && checkInvolvedIds?.length && checkInvolvedIds?.includes(fieldId)) {
      try {
        const form_data = { ...answers, [fieldId]: answer };
        /* eslint-disable no-unused-vars */
        const additionalProps = this.props; const additionalStates = this.state;
        // eslint-disable-next-line no-eval
        eval(beforeSubmitProcess);
        if (form_data) {
          this.setState(prev => ({
            answers: {
              ...form_data,
              [fieldId]: answer
            }
            }), () => {
            if (form_data && Object.keys(form_data || {})?.length > 0) {
              Object.keys(form_data).forEach(formField => (
                this.handleFieldErrorChanged(formField, !form_data?.[formField])
              ));
            }
          });
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  };

  handleSectionErrorMultiField = (v, answer={}) => {
    let level_1 = ''; let level_2 = '';
    let levelRes = true;
    let values = {};
    const { sourceValues } = this.state;
    let ans_level_0 = 'level_0'; let ans_level_1 = 'level_1'; let ans_level_2 = 'level_2';
    if (v.type === 'multi_level') {
     values = v?.values;
   } else {
     values = sourceValues;
     ans_level_0 = 'level_1'; ans_level_1 = 'level_2'; ans_level_2 = 'level_3';
   }

   if (answer[ans_level_0]) {
    for (let v1 in values) {
      if (values[v1].title === answer[ans_level_0]) {
        level_1 = values[v1]?.level_1 || '';
        levelRes = false;
      }
      if (level_1) {
        for (let v2 in level_1) {
          if (level_1[v2].title === answer[ans_level_1]) {
            level_2 = level_1[v2].level_2 || '';
            levelRes = false;
            break;
          } else {
            levelRes = true;
          }
        }
        if (level_2) {
          for (let v3 in level_2) {
            if (level_2[v3].title === answer[ans_level_2]) {
              levelRes = false;
              break;
            } else {
              levelRes = true;
            }
          }
        }
      }
    }
  }
    return levelRes;
  }

  handleSectionErrorChanged = (fieldId, answer, requiredMap, errorsList, formTabFeilds) => {
    const { answers } = this.state;
   const sectionErrors = formTabFeilds.some((v) => {
     if (!v?.type?.toLowerCase()?.includes('multi')) {
       if (v.id === fieldId && requiredMap[v.id] && (!answer || answer?.length === 0)) {
         return true;
       }
       if (v.id === fieldId && !requiredMap[v.id] && (!answer || answer?.length === 0)) {
         return false;
       }
       if (v.id !== fieldId) {
         if (errorsList[v.id]) {
           return errorsList[v.id];
         }
         return requiredMap[v.id] && !answers[v.id]?.length>0;
       }
     } else if (v?.type === 'dataSourceMultiLevel' || v?.type === 'multi_level') {
       if (v.id === fieldId && requiredMap[v.id]) {
          return this.handleSectionErrorMultiField(v, answer);
       } if (v.id !== fieldId && requiredMap[v.id]) {
           return this.handleSectionErrorMultiField(v, answers[v.id]);
       }
     }
     return false;
   });
   return sectionErrors;
  }

  handleFieldErrorChanged = (fieldId, errorValue) => {
    this.setState(prevState => ({
      ...prevState,
      fieldErrors: {
        ...prevState.fieldErrors,
        [fieldId]: errorValue
      }
    }));
  };

  handleUploadAttachments = async (attachment, entity) => {
    let attachments = [];
    if (entity === 'form_signature' && !attachment[0].name) {
      attachments = [...attachment[0]];
    } else {
      attachments = attachment;
    }
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id && e.name) {
        oldAttachments.push(e.name);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await GetFileName.getPermitUploadFileName(newAttachments?.length);
      if (!fileIds) {
        return null; // this stops submit flow
      }
    }
    if (fileIds) {
      await S3Uploads.uploadFiles(
        newAttachments,
        fileIds.filename,
        entity || 'forms',
        this.getErrorAlert
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }

    return attachmentIds;
  }

   validateDefaultFieldsBeforeSubmit = (submittedData) => {
  const {
    answers: { form_date, created_by, ...stateFormData },
    groupedSections,
    errorsList,
    placeHolders,
    requiredMap
  } = this.state;
  const form_data = submittedData || stateFormData;

  const {
    form: { form_version: { schema: { fields } } },
    intl
  } = this.props;

  let updatedErrors = { ...errorsList };
  let updatedSections = [...groupedSections];
  let hasError = false;

  fields.forEach((field) => {
    if (field.type === 'multi_field') return;
    if (field.type === 'header') return;
    if (field.type === 'toggle') return;
    if (field.type === 'datetime' && !field.required) return;
    if (field.type === 'dataSource' && field.dataSourceID === 'ds13') return;
    if (field.conditional) return;

    const value = form_data[field.id];

    const isEmpty = value === null || value === undefined || value === ''
      || (Array.isArray(value) && value.length === 0)
      || (typeof value === 'object'
          && !Array.isArray(value)
          && value !== null
          && Object.keys(value).filter(k => value[k] !== '' && value[k] !== null && value[k] !== undefined).length === 0);

    // Required check
    if ((requiredMap?.[field.id] ?? field.required) && isEmpty) {
      updatedErrors[field.id] = 'This field is required';
      hasError = true;

      const index = this.indexOfSectionHeader(updatedSections, field.id);
      if (index >= 0) updatedSections[index].fieldErrors = true;

      return;
    }

    if (updatedErrors[field.id] === 'This field is required') {
      updatedErrors[field.id] = '';
    }
    // Regex check
    if (field.validators?.length > 0 && value) {
      const validator = field.validators[0];

      if (validator.type === 'Regex' && validator.value) {
        let convertValidtorValueToRegex = validator.value;
        let valueToValidate = value;
        let invalidEmailCount = 0;
        if (validator?.label === 'Custom Validation') {
          if (convertValidtorValueToRegex.endsWith('-')) {
            convertValidtorValueToRegex = convertValidtorValueToRegex.slice(0, -1);
          }
          convertValidtorValueToRegex = `^${convertValidtorValueToRegex}$`;
        }
        if (validator?.label === 'Phone Number' && typeof value === 'string') {
          ({
            phoneValConvert: valueToValidate,
            convertValidtorValueToRegex
          } = getPhoneConvert(value));
        }
        const regex = new RegExp(convertValidtorValueToRegex);
        const hasRegexError = (() => {
          if (validator?.multiple_email && typeof value === 'string' && value?.length) {
            const invalidEmails = value
              .split(',')
              .filter((email) => {
                if (typeof email !== 'string') return false;
                const trimmedEmail = email.trim();
                return trimmedEmail && !regex.test(trimmedEmail);
              });
            invalidEmailCount = invalidEmails.length;
            return invalidEmails.length > 0;
          }
          return !regex.test(valueToValidate);
        })();
        if (hasRegexError) {
          updatedErrors[field.id] = getFieldError(
            validator.label,
            field.id,
            placeHolders,
            invalidEmailCount,
            validator?.multiple_email
          ) || `Invalid ${validator.label || 'format'}`;
          hasError = true;

          const index = this.indexOfSectionHeader(updatedSections, field.id);
          if (index >= 0) updatedSections[index].fieldErrors = true;
        } else {
          updatedErrors[field.id] = '';
        }
      }

      if (validator.type === 'min_max') {
        const { fieldError } = validateMinMax(value, field.validators, false, intl);
        if (fieldError) {
          updatedErrors[field.id] = fieldError;
          hasError = true;

          const index = this.indexOfSectionHeader(updatedSections, field.id);
          if (index >= 0) updatedSections[index].fieldErrors = true;
        } else {
          updatedErrors[field.id] = '';
        }
      }
    }
  });

  this.setState({
    errorsList: updatedErrors,
    groupedSections: updatedSections
  });

  return {
    hasError,
    updatedErrors,
    updatedSections
  };
};

handleMultiColumnGLS = (fieldId, field, ans_values) => {
  const { dataSourceValues } = this.props;
  const specificFieldValues = dataSourceValues[fieldId];
  let finalError;
  for (const [key, value] of Object.entries(ans_values)) {
    if (key === 'level_0') {
      let levelZeroValues = specificFieldValues?.filter(
        levelZeroValue => (levelZeroValue?.name === value)
      );
      if (levelZeroValues?.length === 0) {
        finalError = field?.mandatory_multi_field || false;
      } else if (value !== '' && levelZeroValues?.length > 0) {
        let levelOneValues = levelZeroValues[0].location_levels;
        if (levelOneValues?.length === 0) {
          finalError = false;
        } else {
          finalError = field?.mandatory_multi_field || false;
        }
      }
    } else if (key === 'level_1') {
      let levelZeroValues = specificFieldValues.filter(
        val => (val?.name === ans_values?.level_0)
      );
      let levelOneValues = [];
      let levelTwoValues = [];
      if (levelZeroValues.length > 0) {
        levelOneValues = levelZeroValues[0].location_levels;
      }
      if (ans_values?.level_0 && levelOneValues?.length > 0) {
        levelOneValues = levelOneValues.filter(
          val => val?.title === value
        );
        if (levelOneValues.length === 0) {
          finalError = field?.mandatory_multi_field || false;
        } else if (value !== '' && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues[0].level_1;
          if (levelTwoValues?.length === 0) {
            finalError = false;
          } else {
            finalError = field?.mandatory_multi_field || false;
          }
        }
      }
    } else if (key === 'level_2') {
      let levelZeroValues = specificFieldValues.filter(
        val => (val?.name === ans_values?.level_0)
      );
      let levelOneValues = [];
      let levelTwoValues = [];
      let levelThreeValues = [];
      if (levelZeroValues.length > 0) {
        levelOneValues = levelZeroValues[0].location_levels;
      }
      if (ans_values?.level_0 && ans_values?.level_1 && levelOneValues?.length > 0) {
        levelTwoValues = levelOneValues.filter(
          val => (val?.title === ans_values?.level_1)
        );
        if (levelTwoValues.length === 0) {
          finalError = field?.mandatory_multi_field || false;
        } else if (value !== '' && levelThreeValues?.length > 0) {
          levelThreeValues = levelTwoValues[0].level_1;
          if (levelThreeValues?.length === 0) {
            finalError = false;
          } else {
            finalError = field?.mandatory_multi_field || false;
          }
        }
      }
    } else if (key === 'level_3') {
      let levelZeroValues = specificFieldValues.filter(
        val => (val?.name === ans_values?.level_0)
      );
      let levelOneValues = [];
      let levelTwoValues = [];
      let levelThreeValues = [];
      if (levelZeroValues.length > 0) {
        levelOneValues = levelZeroValues[0].location_levels;
      }
      if (ans_values?.level_0 && ans_values?.level_1 && ans_values?.level_2 && levelOneValues?.length > 0) {
        levelTwoValues = levelOneValues.filter(
          val => (val?.title === ans_values?.level_1)
        );
        levelTwoValues = levelTwoValues[0].level_1;
        levelTwoValues = levelTwoValues.filter(
          val => (val?.title === ans_values?.level_2)
        );
        levelThreeValues = levelTwoValues[0].level_2;
        if (levelThreeValues.length === 0) {
          finalError = false;
        } else if (value !== '' && levelThreeValues?.length > 0) {
          finalError = false;
        }
      }
    }
  }
  return finalError;
};

  handleSectionErrorMultiLevelField = (v, answer={}) => {
    let level_1 = ''; let level_2 = '';
    let levelRes = true;
    let values = v?.values;
    let ans_level_0 = 'level_0'; let ans_level_1 = 'level_1'; let ans_level_2 = 'level_2';

   if (answer[ans_level_0]) {
    // eslint-disable-next-line guard-for-in
    for (let v1 in values) {
      if (values[v1].title === answer[ans_level_0]) {
        level_1 = values[v1]?.level_1 || '';
        levelRes = false;
      }
      if (level_1) {
        for (let v2 in level_1) {
          if (level_1[v2].title === answer[ans_level_1]) {
            level_2 = level_1[v2].level_2 || '';
            levelRes = false;
            break;
          } else {
            levelRes = true;
          }
        }
        if (level_2) {
          for (let v3 in level_2) {
            if (level_2[v3].title === answer[ans_level_2]) {
              levelRes = false;
              break;
            } else {
              levelRes = true;
            }
          }
        }
      }
    }
    }
    return levelRes;
  }

  handleMultiColumnGLS = (fieldId, field, ans_values) => {
    const { dataSourceValues } = this.props;
    const specificFieldValues = dataSourceValues[fieldId];
    let finalError;
    for (const [key, value] of Object.entries(ans_values)) {
      if (key === 'level_0') {
        let levelZeroValues = specificFieldValues?.filter(
          levelZeroValue => (levelZeroValue?.name === value)
        );
        if (levelZeroValues?.length === 0) {
          finalError = field?.mandatory_multi_field || false;
        } else if (value !== '' && levelZeroValues?.length > 0) {
          let levelOneValues = levelZeroValues[0].location_levels;
          if (levelOneValues?.length === 0) {
            finalError = false;
          } else {
            finalError = field?.mandatory_multi_field || false;
          }
        }
      } else if (key === 'level_1') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && levelOneValues?.length > 0) {
          levelOneValues = levelOneValues.filter(
            val => val?.title === value
          );
          if (levelOneValues.length === 0) {
            finalError = field?.mandatory_multi_field || false;
          } else if (value !== '' && levelOneValues?.length > 0) {
            levelTwoValues = levelOneValues[0].level_1;
            if (levelTwoValues?.length === 0) {
              finalError = false;
            } else {
              finalError = field?.mandatory_multi_field || false;
            }
          }
        }
      } else if (key === 'level_2') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        let levelThreeValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && ans_values?.level_1 && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues.filter(
            val => (val?.title === ans_values?.level_1)
          );
          if (levelTwoValues.length === 0) {
            finalError = field?.mandatory_multi_field || false;
          } else if (value !== '' && levelThreeValues?.length > 0) {
            levelThreeValues = levelTwoValues[0].level_1;
            if (levelThreeValues?.length === 0) {
              finalError = false;
            } else {
              finalError = field?.mandatory_multi_field || false;
            }
          }
        }
      } else if (key === 'level_3') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        let levelThreeValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && ans_values?.level_1 && ans_values?.level_2 && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues.filter(
            val => (val?.title === ans_values?.level_1)
          );
          levelTwoValues = levelTwoValues[0].level_1;
          levelTwoValues = levelTwoValues.filter(
            val => (val?.title === ans_values?.level_2)
          );
          levelThreeValues = levelTwoValues[0].level_2;
          if (levelThreeValues.length === 0) {
            finalError = false;
          } else if (value !== '' && levelThreeValues?.length > 0) {
            finalError = false;
          }
        }
      }
    }
    return finalError;
  }

   handleMultiFieldIndividualError = () => {
  const {
    errorListMCG: mcgErrors,
    answers: {
      form_date,
      created_by,
      source,
      name,
      email,
      phone,
      ...form_data
    }
  } = this.state;
  const { form: { form_version: { schema: { fields } } } } = this.props;
  let finalErrorData = [];
  fields.forEach((field) => {
    if (field.type === 'multi_field' && field.multiple_fields && !field.repeat_field) {
      const formValues = form_data[field.id]?.[0] || {};
      if (!formValues || Object.keys(formValues).length === 0) {
        if (field.required) {
          finalErrorData.push(field.title);
        }
        return;
      }
      finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(
        field,
        formValues,
        this.handleSectionErrorMultiField,
        this.handleMultiColumnGLS,
        form_data
      )];
      if (mcgErrors?.[field.id]?.[0]) {
        finalErrorData = [
          ...finalErrorData,
          ...Object.values(mcgErrors[field.id][0]).filter(Boolean)
        ];
      }
    } else if (field.type === 'multi_field' && field.multiple_fields && field.repeat_field) {
      const formValues = form_data[field.id];
      if (!formValues || formValues.length === 0) {
        if (field.required) {
          finalErrorData.push(field.title);
        }
        return;
      }
      formValues.forEach((formValue) => {
        finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(
          field,
          formValue,
          this.handleSectionErrorMultiField,
          this.handleMultiColumnGLS,
          form_data
        )];
      });
      if (mcgErrors?.[field.id]) {
        Object.values(mcgErrors[field.id]).forEach((rowError) => {
          finalErrorData = [...finalErrorData, ...Object.values(rowError || {}).filter(Boolean)];
        });
      }
    }
  });
  return finalErrorData;
};

  handleValidErrors = (errorMCGlist, errorsList, fieldErrors, fieldTitles, customErrors) => {
    let fieldErrorsList = [];
    const multiValidReqFields = errorMCGlist?.flatMap(err => Object.keys(err)?.map(e => e));
    const customReqFields = Object.keys(errorsList || {})?.filter(err => errorsList[err] !== '');
    const reqFields = [...Object.keys(fieldErrors || {})?.filter(t => fieldErrors[t] === true), ...multiValidReqFields, ...customReqFields];
    const uniqueReqFields = new Set(reqFields);
    fieldErrorsList = Array.from(uniqueReqFields)?.map(req => fieldTitles[req]);
    let multiFieldError = this.handleMultiFieldIndividualError();
    fieldErrorsList = [...fieldErrorsList, ...multiFieldError];
    this.setState({ customErrors, showFormErrors: true, fieldErrorsList });
    return fieldErrorsList?.length > 0;
  }

  handleSubmit = async (isDraft) => {
    const {
      fieldErrors,
      answers: {
        form_date,
        created_by,
        source,
        name,
        email,
        phone,
        ...form_data
      },
      signatureFields, errorsList, errorListMCG, groupedSections
    } = this.state;
    const { form: { form_version: { schema: { fields } } }, uniqueFields } = this.props;
    const { actionCreateAnswer, form, location, user } = this.props;
    let operatorAircraftField;
      if (form?.form_version?.schema?.fields?.length > 0) {
        form.form_version.schema.fields.forEach((field) => {
          if (field?.type === 'datetime' && !field?.required) {
            fieldErrors[field.id] = false;
          }
          if (field?.type === 'toggle') {
            fieldErrors[field.id]=false;
          }
          if (field?.type === 'dataSource' && field?.dataSourceID === 'ds13') {
            fieldErrors[field.id] = false;
          }
             if (field?.type === 'multi_field' && form_data?.[field.id]) {
      operatorAircraftField = form_data[field.id]?.[0];
    }
        });
      }
    const multiField = form.form_version.schema.fields.find(
      field => field?.type === 'multi_field' && form_data?.[field.id]
    );
    if (multiField) {
      const { id: fieldId, multiple_fields } = multiField;
      operatorAircraftField = form_data[fieldId]?.[0];

      const hasMissingRequiredField = Object.entries(multiple_fields).some(([key, field]) => {
        if (field.mandatory_multi_field) {
          const value = operatorAircraftField?.[key];
          return (value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0));
        }
        return false;
      });

      if (hasMissingRequiredField) {
        this.setState({ showFormErrors: true });
        return;
      }

      fieldErrors[fieldId] = false;
    }

    const attachmentFields = form?.form_version?.schema?.fields.filter(schemaField => (
      schemaField?.type === 'attachments' || schemaField?.type === 'multi_field'
    ));
    const defaultFormSubmitFields = form?.form_version?.schema?.fields.filter(field => (
      DATE_SUBMIT_FIELD_TYPES.includes(field.type)
      && field?.default_form_submit_date
    )) || [];
    const defaultValidation = isDraft
      ? { hasError: false, updatedErrors: errorsList, updatedSections: groupedSections }
      : this.validateDefaultFieldsBeforeSubmit({ ...form_data });
    const effectiveErrorsList = isDraft ? errorsList : defaultValidation.updatedErrors;

    const hasDefaultErrors = defaultValidation.hasError;

    const noFieldErrors = Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
    );

    const noErrors = isDraft || (!hasDefaultErrors && noFieldErrors);

    const errorsListValues = isDraft ? [] : Object.values(effectiveErrorsList).filter(val => val !== '');
    let updatedErrorListMCG = { ...(errorListMCG || {}) };
    if (!isDraft) {
      fields.forEach((field) => {
        if (field?.type === 'multi_field' && form_data?.[field.id]) {
          updatedErrorListMCG = handleMultiFieldErrorList(
            field,
            form_data[field.id],
            field.id,
            { errorListMCG: updatedErrorListMCG }
          );
        }
      });
      if (JSON.stringify(updatedErrorListMCG) !== JSON.stringify(errorListMCG || {})) {
        this.setState({ errorListMCG: updatedErrorListMCG });
      }
    }
const r = Object.keys(updatedErrorListMCG).map(val => ({ [val]: updatedErrorListMCG[val] }));
   if (!isDraft) {
  const fieldErrorsList = [];
  const fieldTitles = {};

  fields.forEach((field) => {
      fieldTitles[field.id] = field.title;
    });
     fields.forEach((field) => {
       if (field.type === 'multi_field') return;
       if (field.type === 'header') return;
       if (field.type === 'toggle') return;
       if (field.type === 'datetime' && !field.required) return;
       if (field.type === 'dataSource' && field.dataSourceID === 'ds13') return;
       if (field.conditional) return;

       const value = form_data[field.id];
       const isEmpty = value === null || value === undefined || value === ''
        || (Array.isArray(value) && value.length === 0)
        || (typeof value === 'object' && !Array.isArray(value) && value !== null
        && Object.keys(value).filter(k => value[k] !== '' && value[k] !== null && value[k] !== undefined).length === 0);

       if (field.required && isEmpty) {
         fieldErrorsList.push(field.title);
         return;
       }

       if (effectiveErrorsList[field.id]) {
         fieldErrorsList.push(field.title);
       }
     });
     fields.forEach((field) => {
       if (field.type !== 'multi_field') return;

       const multiValues = form_data[field.id];
       let hasError = false;

       if (!multiValues || multiValues.length === 0) {
         if (field.required) hasError = true;
       } else if (updatedErrorListMCG[field.id]) {
         hasError = true;
       } else if (!field.repeat_field) {
         const row = multiValues?.[0] || {};
         hasError = handleMultiGridSpecificFieldError(
           field,
           row,
           this.handleSectionErrorMultiField,
           this.handleMultiColumnGLS,
           form_data
         ).length > 0;
       } else if (Array.isArray(multiValues)) {
         hasError = multiValues.some(row => handleMultiGridSpecificFieldError(
           field,
           row,
           this.handleSectionErrorMultiField,
           this.handleMultiColumnGLS,
           form_data
         ).length > 0);
       }

       if (hasError) {
         fieldErrorsList.push(field.title);
       }
     });
     if (uniqueFields && Object.keys(uniqueFields)?.length > 0) {
       Object.keys(uniqueFields).forEach((uniqField) => {
         if (uniqueFields[uniqField]?.filter(val => val?.value?.replace(/\s/g, '') === form_data?.[uniqField]?.replace(/\s/g, ''))?.length > 0) {
           fieldErrorsList.push(`${fieldTitles?.[uniqField]} already exists. Please enter a different ${fieldTitles?.[uniqField]}`);
         }
       });
     }

     const uniqueErrors = [...new Set(fieldErrorsList)];

     if (uniqueErrors.length > 0) {
       this.setState(prevState => ({
         showFormErrors: true,
         fieldErrorsList: uniqueErrors,
         errorModal: true,
         errorsList: effectiveErrorsList,
         fieldErrors: Object.keys(prevState.fieldErrors || {}).reduce((acc, key) => {
           acc[key] = false;
           return acc;
         }, {}),
         errorListMCG: updatedErrorListMCG
       }));

       return;
     }
   }
      const errorMCGlist = isDraft ? []: r;
    if (noErrors && errorsListValues.length === 0 && errorMCGlist.length === 0) {
      this.setState({ loadingStatus: true });
      if (defaultFormSubmitFields.length > 0) {
        for (let index = 0; index < defaultFormSubmitFields.length; index++) {
          const dateField = defaultFormSubmitFields[index]?.id;
          form_data[dateField] = moment().format();
        }
      }
      if (attachmentFields.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && form_data[attachmentField]?.length > 0) {
            form_data[attachmentField] = form_data[attachmentField]
            .map(item => item?.attachment_id)
            .filter(aid => typeof aid === 'string');
          } else if (schemaField?.type === 'multi_field') {
            const multiAttachmentFields = schemaField?.multiple_fields
              && Object.keys(schemaField?.multiple_fields)?.filter(f => schemaField?.multiple_fields?.[f]?.type?.key === 'attachments');
            if (multiAttachmentFields?.length > 0) {
              for (let multiIndex = 0; multiIndex < multiAttachmentFields.length; multiIndex++) {
                for (let multiDataIndex = 0; multiDataIndex < form_data?.[schemaField?.id]?.length; multiDataIndex++) {
                  const attachments = form_data?.[schemaField?.id]?.[multiDataIndex]?.[multiAttachmentFields[multiIndex]] || [];
                  if (attachments?.length > 0) {
                    form_data[schemaField?.id][multiDataIndex][multiAttachmentFields[multiIndex]] = attachments?.map(attach => (
                      attach?.attachmentUploadId || attach?.name
                    ));
                  }
                }
              }
            }
          }
        }
      }
      if (signatureFields.length > 0) {
        for (let i = 0; i < signatureFields.length; i++) {
          const signatureField = signatureFields[i];
          if (form_data[signatureField]) {
            form_data[signatureField] = await this.handleUploadAttachments([form_data[signatureField]], 'form_signature');
          }
        }
      }
      const tagData = [];
      Object.keys(form_data).forEach((k) => {
        if ((k === 'tags' || k === 'oldTags') && form_data[k] !== null && form_data[k] !== undefined) {
          form_data[k].forEach(tag => tagData.push(tag?.name));
          form_data.tags = tagData;
        }
      });

      fields.forEach((val) => {
        const phoneType = val?.type === 'string' && val?.validators?.length > 0 && val?.validators[0]?.label === 'Phone Number' && val;
        if (phoneType && form_data[phoneType.id]) {
          form_data[phoneType.id] = form_data[phoneType.id][0] + form_data[phoneType.id].slice(1).replace(/[^\d]/g, '');
        }
        if (val?.type === 'dataSourceMultiLevel' && form_data[val?.id]?.location_attachment?.length > 0
          && form_data[val?.id]?.location_attachment[0]?.url) {
          form_data[val.id].location_attachment = form_data[val.id]?.location_attachment[0]?.id;
        }
      });
      const task_details = location?.state?.taskid ? location.state : {};

      const data = {
        form_date: new Date(),
        created_by,
        data: form_data,
        tags: form_data.tags,
        email_date: moment().format(),
        email_form_date: moment().format('MM-DD-YYYYTHH:mm A'),
        task_details,
        portal_tenant: user?.current_tenant?.name
      };
      if (source === FORM_PUBLIC_STATUS) {
        data.source = source;
        data.name = name;
        data.email = email;
        data.phone = phone;
      }
      if (isDraft) {
        data.status = 'draft';
        this.setState({ isDraft: true });
      }
      if (form?.process?.current_step === 'step_1') {
        data.send_back = {
          current_step_id: form?.process?.current_step,
          step_title: 'Step 1 - Form Submission'
        };
      }
      actionCreateAnswer(form?.form_version?.form_id, data);
    }
  };

  doS3Upload = async (files, fileIds, entity, getErrorAlert) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      undefined,
      undefined,
      getErrorAlert
    );
    return response;
  };

  handleTabClick = (index) => {
    const { groupedSections } = this.state;
    if (groupedSections?.length > 0) {
      const { items } = groupedSections[index];
      this.setState({
        formActiveIndex: index,
        formTabFeilds: items,
        loadingStatus: false
      });
    }
  }

  showTabSection = (groupedSections, formActiveIndex) => {
    const { showFormErrors } = this.state;
    return (
      <div className={`${styles.navigation} ${styles.sectionTabsSty}`}>
        {groupedSections?.map((field, index) => {
        let className = '';
        if (showFormErrors && field?.fieldErrors) {
          className = styles.fieldErros;
        } else if (index === formActiveIndex) {
          className = styles.active;
        }
        return (
        <Clickable
          className={className}
          onClick={() => this.handleTabClick(index)}
        >
          <span>{field.header}</span>
        </Clickable>
        );
      })}
      </div>);
  };

  indexOfSectionHeader = (sections, id) => sections.findIndex(val => val.items.some(e => e.id === id));

  render() {
    const { form, location, globalLocationList } = this.props;
    const {
      showFormErrors,
      requiredMap,
      answers,
      apiStatus,
      apiStatusError,
      loadingStatus,
      placeHolders,
      errorsList,
      groupedSections,
      formTabFeilds,
      formActiveIndex,
      opsLogTags,
      isDraft,
      fieldErrors,
      errorListMCG,
      fieldErrorsList,
      errorModal,
      user,
      alert
    } = this.state;
    const title = form ? form.title : 'New Form';
    const icon = form ? form.icon : 'icon2.png';
    const sectionHeaders = formTabFeilds?.filter(field => field.type === 'header');

    const getCustomFieldComponent = fields => (
      <CustomFields
        handleAnswerChanged={(a, b, c) => this.handleAnswerChanged(a, b, c)
        }
        handleFieldErrorChanged={this.handleFieldErrorChanged}
        showFormErrors={showFormErrors}
        requiredMap={requiredMap}
        fields={fields}
        answers={answers}
        handleUploadAttachments={this.handleUploadAttachments}
        edit
        placeHolders={placeHolders}
        errorsList={errorsList}
        handleCheckListAnswer={this.handleCheckListAnswer}
        attachmentRenameOption
        myforms
        fieldErrors={fieldErrors}
        fromForms
        errorListMCG={errorListMCG}
        globalLocationList={globalLocationList}
        defaultLocation={user?.portal_airport?.location?.coordinates}
        handleAttachmentFailedAlert={this.getErrorAlert}
        handleAutoUploadAttachments={this.uploadtoS3}
        entityName="forms"
      />
    );

    return (
      <>
        <SectionHeader
          icon={this.images[icon] && this.images[icon].default}
          translationID="invalid"
          defaultTitle={`${title} #${moment(form?.form_date).format('YY')} - ${form?.order_number
          }`}
        />
        <HeaderBack
          translationID="form.start.back"
          translationDefault="Back to Forms"
          backRoute={this.URL}
          myForms
        >
          { apiStatus ? '' : this.showTabSection(groupedSections, formActiveIndex)}
        </HeaderBack>
        <Loading loadingStatus={loadingStatus} />
        {form && Object.keys(form).length > 0 && !apiStatus && !apiStatusError && (
          <div className={styles.container}>
            <div className={styles.details}>
              <div>
                <p className={styles.instructions}>
                  {form?.form_version?.additionalInfo}
                </p>
                {requiredMap && sectionHeaders?.length > 0 && formTabFeilds?.length > 0
                && sectionHeaders?.length > 0
                && <CollapsibleSections
                    fieldsList={formTabFeilds}
                    getCustomFieldComponent={getCustomFieldComponent}
                    answers={answers} />}
                {requiredMap
                  && formTabFeilds?.length > 0 && !sectionHeaders?.length &&(
                    getCustomFieldComponent(formTabFeilds)
                )}
                {form?.settings?.enable_tags
                  && (
                  <div style={{ marginLeft: '43px' }}>
                    <Tags handleTagSelect={this.handleAnswerChanged} opsLogTags={opsLogTags}
                      handleTagSelectProps={['tags']} module="forms" handleRemoveTag={this.handleRemoveTag}
                      updatedOpslogTags={answers?.tags} updatedOpsOldTags={answers?.oldTags}
                    />
                  </div>
                )}
              </div>
              <div className={styles.footer} style={{ marginTop: 'auto' }}>
                <Button action={formActiveIndex === 0 ? 'tertiary' : 'secondary'}
                  onClick={formActiveIndex === 0 ? this.goBackToForms : () => this.handleTabClick(formActiveIndex - 1)}
                  translationID={formActiveIndex === 0 ? 'inspections.new.cancelBtn' : 'inspections.new.prev'}
                  defaultText={formActiveIndex === 0 ? 'Cancel' : 'Back'}
                />
                {form?.status === 'draft' && (
                  <div className={styles.completeBtn}>
                    <Button
                      action="tertiary"
                      onClick={() => this.handleSubmit(true, 'submit')}
                      translationID="inspections.complete_inspections.save_as_draft"
                      defaultText="Save as Draft"
                    />
                  </div>)}
                <Button
                  action="secondary"
                  onClick={() => {
                    if (groupedSections.length > 0 && groupedSections.length !== formActiveIndex + 1) {
                      this.handleTabClick(formActiveIndex + 1);
                    } else {
                      this.handleSubmit(false);
                    }
                  }}
                  translationID={groupedSections?.length > 0 && groupedSections?.length !== formActiveIndex + 1
                    ? 'inspections.new.next' : 'form.submit_form'}
                  defaultText="Submit Form"
                />
              </div>
            </div>
          </div>
        )}
        {fieldErrorsList?.length > 0 && (
          <Modal
            showIn={errorModal}
            onClose={() => this.setState({ errorModal: false })}
            contentStyles={{
              width: '554px',
              minHeight: '20%'
            }}
          >
            <div className={styles.contentErrorModal}>
              <div className={`${styles.linkModalHeader} ${styles.header}`}>
                <FormattedMessage
                  id="inspection.link.to_form"
                  defaultMessage="Missing Required Information"
                />
                <Clickable
                  onClick={() => this.setState({ errorModal: false })}
                  className={styles.closeIcon}
                >
                  <img src={closeIcon} alt="X" />
                </Clickable>
              </div>
              <div className={`container ${styles.content}`}>
                <ul style={{ color: 'red', textAlign: 'left' }}>
                  {fieldErrorsList && fieldErrorsList.map(error => (
                    <li style={{ margin: '10px 0px' }}>{error}</li>
                  ))}
                </ul>
              </div>
              <div className={styles.errorFooter}>
                <Button
                  action="tertiary"
                  onClick={() => this.setState({ errorModal: false })}
                  translationID="inspections.new.cancelBtn"
                  defaultText="Cancel"
                />
              </div>
            </div>
          </Modal>
        )}
        {(apiStatus || apiStatusError) && (
          <div className={styles.container}>
            <FormSubmitted
              handleGoForms={this.goBackToForms}
              error={apiStatusError}
              apiStatus={apiStatus}
              name={title}
              fromFormDraft
              message={isDraft ?'Your Form Successfully Saved':'Your Form was successfully submitted'}
              icon={icon}
              isDraft={isDraft}
              locationState={location}
            />
          </div>
        )}
        {alert && this.toastAlert()}
      </>
    );
  }
}

DuplicateForm.propTypes = {
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  actionClear: PropTypes.func.isRequired,
 actionCreateAnswer: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  form: state.forms?.formAnswerDetails,
  user: state.auth.profile,
  userlist: state.inspection.userlist,
  dataSourceValues: state.inspection.dataSourceValues,
  dataSourceAction: state.inspection.action,
  updateAction: state.forms.updateFormAnswerAction,
  opslog_tags: state.forms?.getFormsSchema?.opslog_tags,
  Tags: state.forms?.getFormsSchema?.tags,
  createAction: state.forms?.createFormAnswerAction,
  fetchAnswerAction: state.forms?.formAnswerDetailAction,
  getFormsSchemaAction: state.forms?.getFormsSchemaAction,
  globalLocationList: state.forms?.getFormsSchema?.locations,
  createdFormAnswer: state.forms?.formAnswerDetails,
  uniqueFields: state.forms.uniqueFields
});

const mapDispatchToProps = dispatch => ({
  actionFetch: (id) => {
    dispatch(fetchFormAnswerDetails(id));
  },
  actionCreateAnswer: (id, data) => {
      dispatch(createFormAnswer(id, data));
    },
  actionClear: () => {
    dispatch(actionClearForm());
  },
  actionFetchFormSchema: (id) => {
    dispatch(getPortalFormSchema(id));
  },
  acitonGetTabView: () => {
    dispatch(actionSaveTabView('forms'));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DuplicateForm));
